import { ContactRound } from 'lucide-react';

const Communities = () => {
  return (
    <ContactRound />
  );
};

export default Communities;